export default __webpack_public_path__ + "static/media/background.cc42b53d.jpeg";